import * as React from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Tooltip,
  IconButton,
  Drawer,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState, useEffect } from "react";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { Icon } from "@iconify/react";

const CreateEditLimitAccount = ({ refresh, edit = false, row }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accType, setAccType] = useState("default");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setAccType("default");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    const data = {
      acc_no: form.acc_no.value,
      acc_name: form.acc_name.value,
      ifsc: form.ifsc.value,
      acc_type: accType,
      acc_limit: form.acc_limit.value,
      id: edit ? row.id : undefined,
    };

    setLoading(true);

    const api = edit
      ? ApiEndpoints.EDIT_ACCOUNT_LIMIT
      : ApiEndpoints.ADD_ACCOUNT_LIMIT;

    postJsonData(
      api,
      data,
      setLoading,
      (res) => {
        okSuccessToast(res?.data?.message);
        refresh && refresh();
        handleClose();
      },
      (err) => {
        apiErrorToast(err);
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    if (edit && row) {
      setAccType(row.acc_type || "default");
    }
  }, [row]);

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      {edit ? (
        <Tooltip title="Edit Account">
          <IconButton onClick={handleOpen}>
            <Icon icon="raphael:edit" width={22} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Add Account">
          <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon />}
            onClick={handleOpen}
          >
            Add Account
          </Button>
        </Tooltip>
      )}

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box sx={{ width: 400, p: 2 }}>
          {/* Header */}
          <Typography variant="h6" mb={2}>
            {edit ? "Edit Account" : "Create Account"}
          </Typography>

          {/* Form */}
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Account Name"
                  name="acc_name"
                  defaultValue={edit ? row?.acc_name : ""}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Account Number"
                  name="acc_no"
                  defaultValue={edit ? row?.acc_no : ""}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="IFSC"
                  name="ifsc"
                  defaultValue={edit ? row?.ifsc : ""}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Account Type"
                  value={accType}
                  onChange={(e) => setAccType(e.target.value)}
                  required
                >
                  <MenuItem value="default">Select</MenuItem>
                  <MenuItem value="current">Current</MenuItem>
                  <MenuItem value="saving">Saving</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Account Limit"
                  name="acc_limit"
                  type="number"
                  defaultValue={edit ? row?.acc_limit : ""}
                  required
                />
              </Grid>

              {/* Footer Buttons */}
              <Grid item xs={12} display="flex" justifyContent="space-between">
                <Button onClick={handleClose} color="inherit">
                  Cancel
                </Button>

                <Button type="submit" variant="contained" disabled={loading}>
                  {loading ? (
                    <CircularProgress size={20} />
                  ) : edit ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default CreateEditLimitAccount;
